<template>
    <main class="c-app-content is-sidebar-tiny">
        <custom-field type="greenhub" label="Loại rác" />
        <!--<custom-field type="hoian" label="dữ liệu Hội An" />-->
    </main>
</template>

<script>
    import CustomField from './CustomField';

    export default {
        components: {CustomField},
    }
</script>